import { render, staticRenderFns } from "./OnDemandHistory.vue?vue&type=template&id=4e246193&scoped=true&"
import script from "./OnDemandHistory.vue?vue&type=script&lang=js&"
export * from "./OnDemandHistory.vue?vue&type=script&lang=js&"
import style0 from "./OnDemandHistory.vue?vue&type=style&index=0&id=4e246193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e246193",
  null
  
)

export default component.exports